import {IS_LOADING} from 'actions/types/loadingType'

export const handleLoading = () => dispatch => (dispatch({
  type: IS_LOADING
}))